<ng-container *ngIf="!(loading$|async);else loading">
  <div class="main-grid pt-3">

    <div class="top-row">
      <div (click)="back()" class="back">
        <mat-icon>arrow_backward</mat-icon>
        {{'nav.back' | translate}}</div>
      <div class="d-flex justify-content-start align-items-center title">
        {{'offer.externalCoverage.title'|translate}}
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-end top-row right-buttons">

      <button class="d-flex justify-content-between tile-button cursor-pointer blue-border"
              (click)="cancel()">
        <span class="cursor-pointer">
          {{'cancel'|translate}}</span>
      </button>

      <button class="d-flex justify-content-between tile-button cursor-pointer blue-content"
              [disabled]="!(externalCoverageComponent?.allFormsValid$ |async) || uploadInProgress"
              (click)="submit()">
        <span class="cursor-pointer">
          {{'offer.createOffer.showPreview'|translate}}
        </span>
        <mat-icon>arrow_forward</mat-icon>
      </button>

    </div>

    <div class="d-flex left-part">
      <div class="white-box outer-section">
        <app-create-offer-information [isExternalCoverage]="true"></app-create-offer-information>
      </div>
    </div>

    <div class="d-flex right-part">
      <div class="white-box outer-section">
        <app-external-coverage [proposalId]="(proposalTile$|async).id"
                               [maxCoverage]="(1 - (proposalTile$|async).coverage)*100"
                               [hasLead]="hasLead$|async"
                               (uploadInProgress)="receiveUploadStatus($event)"></app-external-coverage>
      </div>
    </div>

  </div>
</ng-container>
<ng-template #loading>
  <div class="d-flex w-100 h-100 align-items-center justify-content-center">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>
</ng-template>
